import script from "./ConfiguracionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracionView.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguracionView.vue?vue&type=style&index=0&id=7e155ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e155ece"]])

export default __exports__